import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { mobileCSS } from '@measures/responsive'
import { ImageTextWrapperProps } from '@widgets/ArticleTextbox/types'

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;

  ${mobileCSS(css`
    flex-direction: column-reverse;
  `)}
`

const PromoNoTextHalfWidth: FunctionComponent<ImageTextWrapperProps> = ({
  children,
}) => <StyledWrapper>{children}</StyledWrapper>

export default PromoNoTextHalfWidth
